<script>

	import { onMount } from 'svelte';
	import { chain, groupBy, map} from 'lodash';
	import { media } from 'svelte-match-media'
	import scrollSnapPolyfill from 'css-scroll-snap-polyfill' // allows us to use scroll snap with other browsers

	import Card from './Card.svelte';
	import CardCarousel from './CardCarousel.svelte'
	import Icon from './Icon.svelte'
	import Switch from './Switch.svelte';
	
	const contentUrl = 'https://opensheet.vercel.app/1v8mRxj-sRMuhrdLUI_LnlXs5EGAlVfIjBz87btX1gB4/content';
	const contentCols = 7 // <- make sure to update this when updating data 

	const colourUrl =  'https://opensheet.vercel.app/1v8mRxj-sRMuhrdLUI_LnlXs5EGAlVfIjBz87btX1gB4/colours';
	const colourCols = 4
	const colourKey = "super_category"

	let data = [];
	
	let wideView = true;

	const load = async function(url, n_columns, parser){
		const res = await fetch(url);
		const json = await res.json();
		const entries = json // await json.feed.entry;
		const promises = entries //entries.map(async d => await d.content.$t);
		const values = await Promise.all(promises)

		return(parser(values, n_columns));
	}

	const getData = async function(){
		let content = await load(contentUrl, contentCols, parseContent);
		let cardColours = await load(colourUrl, colourCols, parseColours);
		
		console.log(content)
		// console.log(content[0].cards[0])
	
		// Add colours to each card based on the colourKey
		content.forEach(d => {
			d.cards.forEach(card => {
				card.colours = {
					dark: cardColours[card[colourKey]].colour_code_dark,
					light:  cardColours[card[colourKey]].colour_code_light,
					underside:  cardColours[card[colourKey]].colour_code_underside, //"rgb(215,215,215)"
				}
			})
		})
		

		return(content);
	}

	onMount(async () => {
		scrollSnapPolyfill()

		data = await getData();
	})


	function parseContent(values, n_columns){
		let rawData = {};

		for (let i = 0; i < values.length; i += 1){ // iterate over rows
			rawData[i] = values[i]
		}
		
		return chain(rawData).groupBy('category').map((value, key) => ({category: key, cards: value})).value()
	}

	function parseColours(values, n_columns){
		let colourData = {};

		for (let i = 0; i < values.length; i += 1){ // iterate over rows		
			colourData[values[i][colourKey]] = values[i]
		}
		
		return colourData
	}


</script>

<header>
	<link rel="preconnect" href="https://fonts.gstatic.com">
	<link rel="stylesheet" href='https://fonts.googleapis.com/css2?family=Literata:ital,wght@0,200..700;1,200..700&family=Rubik:wght@200;300;400;500;600;700&;display=swap' type='text/css'> 
	<div class='header'>
		<img src="GP_logo_RGB.svg" width=100 align='right' > 
		<h1 > Predicting forced displacement: a&nbsp;modelling framework</h1>
		<h2>A project by <a href="https://www.unglobalpulse.org/" target="_blank">UN Global Pulse</a></h2>

	</div>
	<p>Anticipating flows of forced displacement is an important undertaking of many humanitarian aid agencies, in order to provide vulnerable refugees, migrants, and internally displaced persons with shelter, food, and medical care.</p>
	<p>Computational models, like those using machine learning, can be used to better anticipate future arrivals and prepare a humanitarian response. To do this, modellers and researchers need to make decisions about how to structure datasets, choose from a variety of modeling approaches, and weigh various options given different contexts and goals.</p>
	<p>Here, we present a systematic, model-agnostic framework for structuring the prediction problem. We illustrate this framework using sets of modelling choice cards for you to consider as you develop a predictive model. A worksheet to support this process can be found <a href="UNGP Predictive Analytics Modeling Framework.pdf" target="_blank">here</a>.</p>


	{#if $media.desktop}
	<div id="toggle-view-container">
		<span class:faded={wideView}>List view</span>
		<Switch bind:checked={wideView}></Switch>
		<span class:faded={!wideView}>Wide view</span>
	</div>
	<div class="note">Tip: Using shift + scroll will allow you to scroll left and right.</div>
	{/if}
</header>
<main>
	<!-- <div class = "flex-wrapper"> -->
	{#if $media.mobile || !wideView}
		<div class="list-view">
		{#each data as cardGroup}
			<div class = "card-group">
				<h3>{cardGroup.category}</h3>
				<CardCarousel cards={cardGroup.cards}>
					<span slot="left-control"><Icon name="nav-left" colour="white"/></span>
					<span slot="right-control"><Icon name="nav-right" colour="white"/></span>
				</CardCarousel>
			</div>
		{/each}
		</div>
	{/if}
	{#if $media.desktop && wideView}
		<div class = "card-group">
			<CardCarousel cards={data.map(d => d.cards[0])} subCards={data.map(d => d.cards.slice(1))} optionExpandDown={true}>
				<!-- categories={data.map(d => d.category)}  -->
				<span slot="left-control"><Icon name="nav-left" colour="white"/></span>
				<span slot="right-control"><Icon name="nav-right" colour="white"/></span>
			</CardCarousel>
		</div>
	{/if}
	<!-- </div> -->

</main>
<div id="footer">
	<p>Built by Patricia Angkiriwang and Katherine Hoffmann Pham, <a href="https://www.unglobalpulse.org/" target="_blank">UN Global Pulse</a>. </p>
</div>

<style>
	header, #footer {
		padding: 5% 10%; 
		padding-bottom: 1rem;
		margin: 0 auto;
		max-width: 1200px;
	}
	main {
		padding: 0 5%; 
		margin: 0 auto;
		max-width: 1200px;
		text-align: center;
	}

	h1 {
		/* color: #ff3e00; */
		/* text-transform: uppercase; */
		font-size: 4rem;
		font-weight: 100;
		text-align: left;
		margin-bottom: 0.25rem;
	}
	
	h2 {
		font-size: 1.5rem;
		font-weight: 100;
		/* font-style: italic; */
		margin-top: 0.5em;
		margin-bottom: 1.7em;
	}

	h3 {
		text-transform: uppercase;
		font-size: 2rem;
		font-weight: 100;
	}

	p {
		font-weight: 300;
		line-height: 1.5;
	}

	@media only screen and (max-width:1200px) {
		h1 {
			font-size: 3.5rem;
		}
	}

	@media only screen and (max-width:800px) {
		h1 {
			font-size: 3rem;
		}
		h2 {
			font-size: 1.3rem;
		}
		h3 {
			font-size: 1.5rem;
		}
		p {
			font-size: 1rem;
		}
	}
    @media only screen and (max-width: 480px) {
		h1 {
			font-size: 2.2rem;
		}
		h2 {
			font-size: 1rem;
		}
		h3 {
			font-size: 1.2rem;
		}
		p {
			font-size: 1rem;
		}
    }

	.list-view > .card-group {
		margin-bottom: 6rem;
	}

	/* .flex-wrapper {
		display:flex;
		flex-wrap: wrap;
	} */

	#toggle-view-container {
      display: flex;
      align-items: center;
      justify-content: flex-end;
	  font-size: 0.8rem;
	  margin-bottom: 20px;
  	}
	
	#toggle-view-container > .faded {
		color: #777;
	}

	#footer p, .note {
		font-size: 0.8rem;
		text-align: right;
	}

	.note {
		margin-bottom: 10px;
		color: #999;
	}
	


</style>